import { Injectable, inject, computed } from '@angular/core';
import { ModuleTerminologyService } from './module-terminology.service';

export interface SitesTerminology {
  nav_label: string;
  singular: string;
  plural: string;
}

/**
 * What the Sites / Properties module is called.
 *
 * A thin wrapper over {@link ModuleTerminologyService}, which holds the naming for every module
 * and stores it PER TENANT on the server. This shape is kept so existing consumers (sidebar,
 * shells, settings pages) need no changes.
 */
@Injectable({ providedIn: 'root' })
export class SitesTerminologyService {
  private readonly modules = inject(ModuleTerminologyService);

  /** Signal so templates repaint the moment a rename is saved. */
  readonly terminology = computed<SitesTerminology>(() => this.modules.for('sites')());

  async set(value: SitesTerminology): Promise<void> {
    await this.modules.save('sites', value);
  }
}
